import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Copy,
  Check,
} from "lucide-react";

import moment from "moment";
import { useUserStore } from "../store/useUser";
import _ from "lodash";
import UserActionModal, {
  UserActionType,
} from "./dashboard-components/users/SuspendUserModal";
import ActionDropdown from "./dashboard-components/users/ActionDropDown";
import { useUserStatus } from "../sevices/hooks/admin";
import { toast } from "sonner";

// Action types enum
export enum ActionType {
  UserDetails = "USER_DETAILS",
  Edit = "EDIT",
  Suspend = "SUSPEND",
  Activate = "ACTIVATE",
  Block = "BLOCK",
  Delete = "DELETE",
}

interface PaginatedUserResponse {
  data: any[];
  onPageChange: (page: number) => void;
  searchTerm?: string;
  page: number;
  totalPages: number;
  isLoading: boolean;
  isBusiness?: boolean;
  refetchTable: () => Promise<any>;
  onAction?: (action: ActionType, userId: string) => void;
}

const CustomerTable = ({
  data,
  onPageChange,
  searchTerm = "",
  page = 1,
  totalPages = 1,
  isLoading,
  isBusiness = false,
  onAction,
  refetchTable,
}: PaginatedUserResponse) => {
  const [copiedId, setCopiedId] = useState(null);
  const setUserDetailsModal = useUserStore((state) => state.setShowUserDetails);
  const setUserId = useUserStore((state) => state.setSelectedUsersId);
  const updateStatus = useUserStatus();
  // State for user action modal
  const [currentAction, setCurrentAction] = useState({
    action: "",
    type: null,
    user: null,
    isLoading: false,
  });
  // @ts-ignore
  const actualTotalPages = data?.totalPages || totalPages || 1;

  // Ensure we have a valid page number
  const currentPage = page || 1;

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(actualTotalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handleFirstPage = () => onPageChange(1);
  const handleLastPage = () => onPageChange(totalPages);
  const handlePrevPage = () => onPageChange(Math.max(1, page - 1));
  const handleNextPage = () => onPageChange(Math.min(totalPages, page + 1));

  // @ts-ignore
  // const filteredData = data?.data?.filter((item) => {
  //   if (!searchTerm) return true;

  //   if (isBusiness) {
  //     return (
  //       item?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item?.refereeCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item?.businessName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item?.contactPerson?.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //   } else {
  //     return (
  //       item?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item?.refereeCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item?.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //   }
  // });

  const filteredData = React.useMemo(() => {
    // First check if data exists and is an array
    const dataArray = Array.isArray(data)
      ? data
      : //@ts-ignore
      Array.isArray(data?.data)
      ? //@ts-ignore
        data.data
      : [];

    if (!searchTerm) return dataArray;

    // Now filter the array
    //@ts-ignore
    return dataArray.filter((item) => {
      if (isBusiness) {
        return (
          item?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.refereeCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.businessName
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item?.contactPerson?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      } else {
        return (
          item?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.refereeCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
    });
  }, [data, searchTerm, isBusiness]);

  const handleCopyCode = (code: string, userId: React.SetStateAction<null>) => {
    navigator.clipboard.writeText(code);
    setCopiedId(userId);

    // Reset copied status after 2 seconds
    setTimeout(() => {
      setCopiedId(null);
    }, 2000);
  };

  // Function to get status badge styling
  const getStatusBadgeStyle = (status: any) => {
    status = (status || "").toLowerCase();

    if (!status) return "bg-gray-100 text-gray-800"; // Default for null/empty

    switch (status) {
      case "active":
      case "approved":
      case "verified":
        return "bg-green-100 text-green-800";
      case "pending":
      case "in review":
      case "in progress":
        return "bg-yellow-100 text-yellow-800";
      case "blocked":
      case "suspended":
      case "rejected":
        return "bg-red-100 text-red-800";
      case "inactive":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-blue-100 text-blue-800";
    }
  };

  // Handle action from dropdown

  const handleTableAction = (action: any, user: any) => {
    if (action === ActionType.UserDetails) {
      setUserId(user?.userId);
      setUserDetailsModal(true);
      return;
    }

    // Map local action to modal action type
    let modalActionType = null;
    switch (action) {
      case ActionType.Suspend:
        modalActionType = UserActionType.Suspended;
        break;
      case ActionType.Activate:
        modalActionType = UserActionType.Activate;
        break;
      case ActionType.Block:
        modalActionType = UserActionType.Blocked;
        break;
      case ActionType.Delete:
        modalActionType = UserActionType.Deleted;
        break;
    }

    if (modalActionType) {
      console.log(modalActionType, "hththt");

      setCurrentAction({
        action,
        //@ts-ignore
        type: modalActionType,
        user,
        isLoading: false,
      });
    }
    console.log(user, "user");
    // Also pass to parent component if handler exists
    if (onAction) {
      console.log(":Action here");
      onAction(action, user);
    }
  };
  console.log(currentAction, "currentAction");
  // Handle confirm action
  // const handleConfirmAction = async () => {
  //   if (!currentAction.user) return;
  //   console.log(currentAction, "hgkfkgjbnfuginbkffnjbhyasvyhebfjdfjgdtgjdlv");
  //   setCurrentAction({
  //     ...currentAction,
  //     isLoading: true,
  //   });

  //   try {
  //     const res = updateStatus.mutateAsync({
  //       //@ts-ignore
  //       userId: currentAction?.user?.userId,
  //       status: _.lowerCase(currentAction.type!),
  //     });

  //     console.log(res, "jrjjrjr");
  //     refetchTable();
  //     toast("Status updated successfully");
  //     // refetch();
  //     // }
  //     // Simulate API call with timeout
  //     // await new Promise((resolve) => setTimeout(resolve, 1000));

  //     // Close modal after successful action
  //     setCurrentAction({
  //       action: "",
  //       type: null,
  //       user: null,
  //       isLoading: false,
  //     });
  //   } catch (error) {
  //     console.error("Error performing action:", error);
  //   }
  // };
  const handleConfirmAction = async () => {
    if (!currentAction.user) return;

    setCurrentAction({
      ...currentAction,
      isLoading: true,
    });

    try {
      await updateStatus.mutateAsync({
        //@ts-ignore
        userId: currentAction?.user?.userId,
        status: _.lowerCase(currentAction.type!),
      });

      // Make sure to await the refetch to ensure data is updated
      await refetchTable();
      toast("Status updated successfully");

      // Close modal after successful action
      setCurrentAction({
        action: "",
        type: null,
        user: null,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error performing action:", error);
      toast.error("Failed to update status");
      setCurrentAction({
        ...currentAction,
        isLoading: false,
      });
    }
  };
  // Define columns based on user type
  // const regularColumns = [
  //   { key: "sn", label: "S/N", align: "left" },
  //   { key: "createdAt", label: "Date/Time", align: "left" },
  //   { key: "fullName", label: "Full Name", align: "left" },
  //   { key: "invitationCode", label: "User's Invitation Code", align: "left" },
  //   { key: "email", label: "Email", align: "left" },

  //   { key: "profileStatus", label: "Profile Status", align: "left" },
  //   { key: "kycstatus", label: "KYC Status", align: "left" },
  //   { key: "invitedBy", label: "Referred By", align: "left" },
  //    { key: "refereeCode", label: "Referee's Invitation Code", align: "left" },
  //   { key: "transactionCount", label: "Transaction Count", align: "left" },
  //   { key: "action", label: "Actions", align: "left" },
  // ];

  // const businessColumns = [
  //   { key: "sn", label: "S/N", align: "left" },
  //   { key: "date", label: "Date/Time", align: "left" },
  //   { key: "businessName", label: "Business Name", align: "left" },
  //   { key: "contactPerson", label: "Contact Person", align: "left" },
  //   { key: "refereeCode", label: "Referral Code", align: "left" },
  //   { key: "email", label: "Email", align: "left" },
  //   { key: "phoneNumber", label: "Phone Number", align: "left" },
  //   { key: "profileStatus", label: "Profile Status", align: "left" },
  //   { key: "kycstatus", label: "KYC Status", align: "left" },
  //   { key: "invitedBy", label: "Invited By", align: "left" },
  //   { key: "transactionCount", label: "Transaction Count", align: "left" },
  //   { key: "action", label: "Actions", align: "left" },
  // ];

  const regularColumns = [
    { key: "sn", label: "S/N", align: "left" },
    { key: "createdAt", label: "Date/Time", align: "left" },
    { key: "fullName", label: "Full Name", align: "left" },
    { key: "invitationCode", label: "User's Invitation Code", align: "left" },
    { key: "email", label: "Email", align: "left" },
    { key: "profileStatus", label: "Profile Status", align: "left" },
    { key: "kycStatus", label: "KYC Status", align: "left" },
    { key: "invitedBy", label: "Referred By", align: "left" },
    { key: "refereeCode", label: "Referee's Invitation Code", align: "left" },
    { key: "transactionCount", label: "Transaction Count", align: "left" },
    { key: "action", label: "Actions", align: "left" },
  ];

  const businessColumns = [
    { key: "sn", label: "S/N", align: "left" },
    { key: "date", label: "Date/Time", align: "left" },
    { key: "businessName", label: "Business Name", align: "left" },
    { key: "contactPerson", label: "Contact Person", align: "left" },

    { key: "email", label: "Email", align: "left" },
    { key: "phoneNumber", label: "Phone Number", align: "left" },
    { key: "profileStatus", label: "Profile Status", align: "left" },
    { key: "kycstatus", label: "KYC Status", align: "left" },
    { key: "invitedBy", label: "Referred By", align: "left" },
    { key: "refereeCode", label: "Referee's Invitation Code", align: "left" },
    { key: "transactionCount", label: "Transaction Count", align: "left" },
    { key: "action", label: "Actions", align: "left" },
  ];

  const columns = isBusiness ? businessColumns : regularColumns;

  const startIndex = (page - 1) * 10;
  console.log(filteredData, "filteredData");
  console.log(currentAction, "currentAction");
  return (
    <>
      <div className="bg-white rounded-lg shadow-sm w-full">
        <div className="overflow-x-auto">
          <table className="appearance-none bg-white min-w-full mb-6">
            <thead className="bg-[#fff] appearance-none">
              <tr className="border-b bg-gray-50">
                {columns.map((column) => (
                  <th
                    key={column.key}
                    className={`font-normal text-sm text-primary py-4 whitespace-nowrap px-4 border-r border-slate-50 ${
                      column.align === "right" ? "text-right" : "text-left"
                    }`}
                  >
                    <span className="text-[#5C6F7F] font-bold text-[12px] leading-[18px]">
                      {column.label}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="mt-3 pt-3 w-full space-y-8 border-r border-slate-50">
              {(filteredData || []).map((user: any, index: number) => {
                const date = moment(user.createdAt || user.date).format("lll");
                const serialNumber = startIndex + index + 1;

                return (
                  <tr
                    key={user.userId || index}
                    className="appearance-none my-4 border border-slate-50 even:bg-white odd:bg-slate-100"
                  >
                    {columns.map((col) => {
                      switch (col.key) {
                        case "sn":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {serialNumber}
                            </td>
                          );
                        case "date":
                        case "createdAt":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {date}
                            </td>
                          );
                        case "businessName":
                          return isBusiness ? (
                            <td
                              onClick={() => {
                                setUserDetailsModal(true);
                                setUserId(user.userId);
                              }}
                              className="font-normal text-sm text-[#0eb683] py-4 px-4 hover:underline cursor-pointer"
                            >
                              {user.businessName}
                            </td>
                          ) : null;
                        case "contactPerson":
                          return isBusiness ? (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.contactPerson}
                            </td>
                          ) : null;
                        case "fullName":
                          return !isBusiness ? (
                            <td
                              onClick={() => {
                                setUserDetailsModal(true);
                                setUserId(user.userId);
                              }}
                              className="font-normal text-sm text-[#0eb683] py-4 px-4 hover:underline cursor-pointer"
                            >
                              {user.fullName}
                            </td>
                          ) : null;
                        case "invitationCode":
                          return !isBusiness ? (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.invitationCode}
                            </td>
                          ) : null;
                        case "email":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.email}
                            </td>
                          );
                        case "phoneNumber":
                          return isBusiness ? (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.phoneNumber}
                            </td>
                          ) : null;
                        case "profileStatus":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              <span
                                className={`px-2 py-1 rounded-full text-xs ${getStatusBadgeStyle(
                                  user.profileStatus
                                )}`}
                              >
                                {_.startCase(user.profileStatus) || "Not Set"}
                              </span>
                            </td>
                          );
                        case "kycstatus":
                        case "kycStatus":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              <span
                                className={`px-2 py-1 rounded-full text-xs ${getStatusBadgeStyle(
                                  user.kycstatus ?? user?.kycStatus
                                )}`}
                              >
                                {_.startCase(
                                  user.kycstatus ?? user?.kycStatus
                                ) || "Not Started"}
                              </span>
                            </td>
                          );
                        case "invitedBy":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.invitedBy || "N/A"}
                            </td>
                          );
                        case "refereeCode":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              <div className="flex items-center gap-2">
                                <span>{user.refereeCode}</span>
                                <button
                                  onClick={() =>
                                    handleCopyCode(
                                      user.refereeCode,
                                      user.userId
                                    )
                                  }
                                  className="p-1 hover:bg-gray-100 rounded-full transition-all"
                                  title="Copy referral code"
                                >
                                  {copiedId === user.userId ? (
                                    <Check className="h-4 w-4 text-green-500" />
                                  ) : (
                                    <Copy className="h-4 w-4 text-gray-500" />
                                  )}
                                </button>
                              </div>
                            </td>
                          );
                        case "transactionCount":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              {user.transactionCount || 0}
                            </td>
                          );
                        case "action":
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              <ActionDropdown
                                user={user}
                                onAction={(action, userData) =>
                                  handleTableAction(action, userData)
                                }
                              />
                            </td>
                          );
                        default:
                          return (
                            <td className="font-normal text-sm text-[#202223] py-4 px-4">
                              N/A
                            </td>
                          );
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-4 border-t">
            <div className="flex items-center gap-1 order-2 sm:order-1">
              {/* First page button */}
              <button
                onClick={handleFirstPage}
                disabled={currentPage === 1}
                className={`p-2 rounded-md transition-all ${
                  currentPage === 1
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-700 hover:bg-gray-100 hover:text-[#0eb683]"
                }`}
                aria-label="Go to first page"
              >
                <ChevronsLeft className="h-4 w-4" />
              </button>

              {/* Previous page button */}
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={`p-2 rounded-md transition-all ${
                  currentPage === 1
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-700 hover:bg-gray-100 hover:text-[#0eb683]"
                }`}
                aria-label="Go to previous page"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>

              {/* Page numbers */}
              <div className="flex gap-1">
                {getPageNumbers().map((pageNum) => (
                  <button
                    key={pageNum}
                    onClick={() => onPageChange(pageNum)}
                    className={`w-8 h-8 flex items-center justify-center rounded-md ${
                      pageNum === currentPage
                        ? "bg-[#0eb683] text-white font-medium"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                    aria-label={`Go to page ${pageNum}`}
                    aria-current={pageNum === currentPage ? "page" : undefined}
                  >
                    {pageNum}
                  </button>
                ))}
              </div>

              {/* Next page button */}
              <button
                onClick={handleNextPage}
                disabled={currentPage === actualTotalPages}
                className={`p-2 rounded-md transition-all ${
                  currentPage === actualTotalPages
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-700 hover:bg-gray-100 hover:text-[#0eb683]"
                }`}
                aria-label="Go to next page"
              >
                <ChevronRight className="h-4 w-4" />
              </button>

              {/* Last page button */}
              <button
                onClick={handleLastPage}
                disabled={currentPage === actualTotalPages}
                className={`p-2 rounded-md transition-all ${
                  currentPage === actualTotalPages
                    ? "text-gray-300 cursor-not-allowed"
                    : "text-gray-700 hover:bg-gray-100 hover:text-[#0eb683]"
                }`}
                aria-label="Go to last page"
              >
                <ChevronsRight className="h-4 w-4" />
              </button>
            </div>

            {/* Page info */}
            <div className="text-sm text-gray-600">
              Page <span className="font-medium">{currentPage}</span> of{" "}
              <span className="font-medium">{actualTotalPages}</span>
            </div>
          </div>
        </div>
      </div>

      {/* User Action Modal */}
      {currentAction.type && (
        <UserActionModal
          isOpen={true}
          actionType={currentAction.type}
          onClose={() =>
            setCurrentAction({
              action: "",
              type: null,
              user: null,
              isLoading: false,
            })
          }
          onConfirm={handleConfirmAction}
          isLoading={currentAction.isLoading}
          userName={
            //@ts-ignore
            currentAction.user?.fullName ||
            //@ts-ignore
            currentAction.user?.businessName ||
            "this user"
          }
        />
      )}
    </>
  );
};

export default CustomerTable;
